import api from "../api";
export default {
    namespaced: true,
    state: {
        complaints: {},
        complaint: {}
    },
    getters: {

    },
    actions: {

        async get_complaints({ commit }) {
            try {
                api.get("/v1/complaints")
                    .then((res) => {
                        commit("GET_COMPLAINTS", res.data);
                    })
                    .catch((error) => {
                        commit("ERROR_COMPLAINT", error);
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_COMPLAINT", e);
            }
        },

        async get_complaint({ commit }, id) {
            try {
                api.get("/v1/complaints/"+id)
                    .then((res) => {
                        commit("GET_COMPLAINT", res.data);
                    })
                    .catch((error) => {
                        commit("ERROR_COMPLAINT", error);
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_COMPLAINT", e);
            }
        },

        async get_store_complaints({ commit }, store_id) {
            try {
                api.get("/v1/complaints/index_to_store/"+store_id)
                    .then((res) => {
                        commit("GET_COMPLAINTS", res.data);
                    })
                    .catch((error) => {
                        commit("ERROR_COMPLAINT", error);
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_COMPLAINT", e);
            }
        },
        
        async get_store_complaint({ commit }, id) {
            try {
                api.get("/v1/complaints/show_to_store/"+id)
                    .then((res) => {
                        commit("GET_COMPLAINT", res.data);
                    })
                    .catch((error) => {
                        commit("ERROR_COMPLAINT", error);
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_COMPLAINT", e);
            }
        },

        async create_complaints({ commit }, payload = []) {
            try {
                const response = await api.post("/v1/complaints/", payload)
                return response.data;    
            } catch (e) {
                commit("ERROR_COMPLAINT", e);
            }
        },

        async add_message({ commit }, payload = []) {
            try {
                api.post("/v1/complaint/add_message", payload)
                    .then((res) => {
                        commit("GET_COMPLAINT", res?.data);
                    })
                    .catch((error) => {
                        commit("ERROR_COMPLAINT", error);
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_COMPLAINT", e);
            }
        },

        async block_complaint({ commit }, payload = []) {
            try {
                api.get("/v1/complaints/block_complaint/"+payload.who+"/"+payload.id)
                    .then((res) => {
                        commit("GET_COMPLAINT", res?.data);
                    })
                    .catch((error) => {
                        commit("ERROR_COMPLAINT", error);
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_COMPLAINT", e);
            }
        },

        

    },
    mutations: {
        GET_COMPLAINTS(state, data) {
            state.complaints = data;
        },
        GET_COMPLAINT(state, data) {
            console.log("data")
            state.complaint = data;
        },
        ERROR_COMPLAINT(state, data) {
            console.log(data);
        },

    }
}